import { render, staticRenderFns } from "./next1.vue?vue&type=template&id=4b846edc&scoped=true&"
import script from "./next1.vue?vue&type=script&lang=js&"
export * from "./next1.vue?vue&type=script&lang=js&"
import style0 from "./next1.vue?vue&type=style&index=0&id=4b846edc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b846edc",
  null
  
)

export default component.exports